module.exports = __webpack_public_path__ + "img/yqh2.fd297262.jpg";